import React from 'react';
import { Check } from 'lucide-react';
export function WhatYouReceiveSection() {
  const items = ['Guía digital paso a paso', 'Checklist de mochila sensorial', 'Plan de acción de 60 segundos', 'Diario de disparadores', 'Tarjeta visual imprimible', 'Acceso inmediato en español'];
  return <section className="bg-white py-12 md:py-16 px-5" data-id="element-217">
      <div className="max-w-2xl mx-auto" data-id="element-218">
        <div className="text-center mb-8" data-id="element-219">
          <h2 className="text-2xl md:text-3xl font-bold text-[#2D1F0E] mb-3" data-id="element-220">
            Qué recibes exactamente al acceder hoy
          </h2>
          <p className="text-[0.95rem] md:text-base text-[#6B5D4F] leading-relaxed" data-id="element-221">
            Todo está pensado para darte claridad práctica en el momento
            difícil, sin improvisar.
          </p>
        </div>

        <div className="bg-[#FDF8F0] rounded-2xl p-6 md:p-8 border border-[#D4A853]/20" data-id="element-222">
          <div className="space-y-3" data-id="element-223">
            {items.map((item, idx) => <div key={idx} className="flex items-center gap-3" data-id="element-224">
                <Check className="w-5 h-5 text-[#4A6741] flex-shrink-0" data-id="element-225" />
                <span className="text-[#2D1F0E] font-medium text-[0.9rem] md:text-base" data-id="element-226">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}